import UserPrefferenceActions from './UserPrefferenceActions';
import { updateState } from 'utils';

const initialState = {
  isDarkMode: true,
  isListView: false,
  filterMode: 'all'
};

const { SET_DARK_MODE, SET_IS_LIST_VIEW, SET_FILTER_MODE } = UserPrefferenceActions;

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DARK_MODE:
      return updateState(state, { isDarkMode: action.payload });

    case SET_IS_LIST_VIEW:
      return updateState(state, { isListView: action.payload });

    case SET_FILTER_MODE:
      return updateState(state, { filterMode: action.payload });

    default:
      return state;
  }
};
